import { constants } from '../../helpers';
import { DateRangeFlexSalesProps } from '../DateRangeFlexSales';
import ReportAccountingDateRangeFilter from '../ReportFilters/filters/AccountingDateRangeFilter';

type AccountingDateRangeFilterProps = Pick<DateRangeFlexSalesProps<Date>, 'spacing'> & {
  maxDaysBetween?: number;
  requiredIncomplete?: boolean;
};

const AccountingDateRangeFilter = (props: AccountingDateRangeFilterProps) => (
  <ReportAccountingDateRangeFilter {...props} maxDate={constants.reportGcsFilterRangeMaxDate} />
);

export default AccountingDateRangeFilter;
